import { useToast } from "@/components/ui/use-toast";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { EmailTypeService } from "@/services/emailType";
import { UpdateEmailTypeRolesPayload } from "@/types/emailType";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useUpdateEmailTypeRolesMutation = (emailTypeId: string) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const queryClient = useQueryClient();

  return useMutationWithErrorHandling({
    mutationFn: (payload: UpdateEmailTypeRolesPayload) =>
      EmailTypeService.updateRoles(emailTypeId, payload),
    errorTitle: t("emailTypes.errors.updateRoles"),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["emailType", emailTypeId] }),
        queryClient.invalidateQueries({
          queryKey: ["emailTypeAvailableRoles"],
        }),
        queryClient.invalidateQueries({ queryKey: ["emailTypes"] }),
      ]);
      toast({ title: t("emailTypes.success.updateRoles") });
    },
  });
};
